import { Button, Col, Form, Input, Row, Upload } from 'antd';
import { useEffect } from 'react';

const RoomForm = ({
  onEditFinish,
  normFile,
  roomData,
  rooms,
  isEditSettings,
  // setEditSettings,
}) => {
  const [editForm] = Form.useForm();
  const { TextArea } = Input;

  useEffect(() => {
    editForm.setFieldsValue({
      title: roomData?.title,
      description: roomData?.description,
    });
  }, [roomData]);

  useEffect(() => {
    if (rooms?.updateSuccess) {
      editForm.resetFields();
    }
  }, [rooms?.updateSuccess]);

  return (
    <Form form={editForm} onFinish={onEditFinish}>
      <Form.Item
        label="Name"
        name="title"
        rules={[{ required: true, message: 'Please input room title!' }]}
      >
        <Input
          name="title"
          style={{ borderRadius: '5px' }}
          disabled={!isEditSettings}
        />
      </Form.Item>
      <Form.Item label="Description" name="description">
        <TextArea
          name="description"
          rows={8}
          style={{ borderRadius: '5px' }}
          disabled={!isEditSettings}
        />
      </Form.Item>
      <Row>
        <Col span={12}>
          <Form.Item label="Image">
            <Form.Item
              name="image"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <div className=" border p-1" style={{ borderRadius: '8px' }}>
                <Upload
                  listType="picture"
                  className="mt-1 m-1 d-flex flex-column border-0  justify-content-center upload-list-inline  h-100"
                  maxCount={1}
                >
                  <Button
                    className="border-0 w-100 h-100 py-5 button-hover-border"
                    style={{
                      fontSize: '16px',
                      borderRadius: '8px',
                      background: 'rgb(228, 230, 235)',
                    }}
                    disabled={!isEditSettings}
                  >
                    <i className="fas fa-images mr-1"></i>
                    Upload
                  </Button>
                </Upload>
              </div>
              {/* <Upload listType="picture" className="upload-list-inline" maxCount={1}>
                <Button icon={<UploadOutlined rev="" />}>Upload</Button>
              </Upload> */}
            </Form.Item>
          </Form.Item>
        </Col>
      </Row>
      {isEditSettings && (
        <div className="d-flex justify-content-end ">
          <Form.Item>
            <Button
              type="primary"
              className="px-5"
              style={{ borderRadius: '5px' }}
              htmlType="submit"
              loading={rooms?.updateLoading}
            >
              Save
            </Button>
          </Form.Item>
        </div>
      )}
    </Form>
  );
};

export default RoomForm;
